export default __webpack_public_path__ + "static/media/Preference banner.3f7258a0.jpg";